// import * as React from "react";
// import { useState, useEffect } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import Drawer from "@mui/material/Drawer";
// import CssBaseline from "@mui/material/CssBaseline";
// import MuiAppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import List from "@mui/material/List";
// import Typography from "@mui/material/Typography";
// import Divider from "@mui/material/Divider";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import GroupIcon from "@mui/icons-material/Group";
// import Button from "@mui/material/Button";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import { Grid, Table, TableCell, TableHead, TableRow } from "@mui/material";
// import { useAuth } from "../Components/Authcontext";
// import axios from "axios";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import dayjs from "dayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import TableBody from "@mui/material/TableBody";
// import Paper from "@mui/material/Paper";

// const drawerWidth = 240;

// const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
//   ({ theme, open }) => ({
//     flexGrow: 1,
//     padding: theme.spacing(3),
//     transition: theme.transitions.create("margin", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     marginLeft: `-${drawerWidth}px`,
//     ...(open && {
//       transition: theme.transitions.create("margin", {
//         easing: theme.transitions.easing.easeOut,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//       marginLeft: 0,
//     }),
//   })
// );

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   transition: theme.transitions.create(["margin", "width"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     width: `calc(100% - ${drawerWidth}px)`,
//     marginLeft: `${drawerWidth}px`,
//     transition: theme.transitions.create(["margin", "width"], {
//       easing: theme.transitions.easing.easeOut,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   padding: theme.spacing(0, 1),
//   // necessary for content to be below app bar
//   ...theme.mixins.toolbar,
//   justifyContent: "flex-end",
// }));

// export default function Attendance() {
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(false);

//   //-----------------------------------------------------------------------------------------------------------------------------------------------//

//   const [searchTerm, setSearchTerm] = useState("");
//   console.log("searchTerm:", searchTerm);
//   const [SearchResults, setSearchResults] = useState([]);

//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   useEffect(() => {
//     const interval = setInterval(() => {
//       handleSearch();
//     }, 1000);
//     return () => {
//       clearInterval(interval);
//     };
//   }, [searchTerm, selectedDate]);

//   const handleSearch = async () => {
//     try {
//       axios
//         .get(
        
//           `https://esystems.cdl.lk/backend-Test/RFIDAttendance/RFIDForDGES/GetRFIDdetails?date=${selectedDate.format(
//             "YYYY-MM-DD"
//           )}`
//         )
//         .then((response) => {
//           setSearchResults(response.data.ResultSet);
//         });
//     } catch (error) {
//       console.error(error);
//     }
//   };
 
//   const [box1Open, setBox1Open] = React.useState(false);
  
//   const { logout } = useAuth();
//   const handleLogout = () => {
//     logout();
//   };

//   const handleBox1Toggle = () => {
//     setBox1Open(!box1Open);
  
//   };


//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />
//       <AppBar position="fixed" open={open} sx={{ backgroundColor: " #080c6d" }}>
//         <Toolbar>
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             onClick={handleDrawerOpen}
//             edge="start"
//             sx={{ mr: 2, ...(open && { display: "none" }) }}
//           >
//             <MenuIcon />
//           </IconButton>
//           <Typography variant="h6" noWrap component="div">
//             Attend Me
//           </Typography>

//           <Button
//             variant="contained"
//             color="error"
//             onClick={handleLogout}
//             sx={{ marginLeft: "auto" }}
//           >
//             Logout
//           </Button>
//         </Toolbar>
//       </AppBar>
//       <Drawer
//         sx={{
//           width: drawerWidth,
//           flexShrink: 0,
//           "& .MuiDrawer-paper": {
//             width: drawerWidth,
//             boxSizing: "border-box",
//             backgroundColor: open ? " #080c6d" : "initial",
//           },
//         }}
//         variant="persistent"
//         anchor="left"
//         open={open}
//       >
//         <DrawerHeader>
//           <IconButton onClick={handleDrawerClose}>
//             {theme.direction === "ltr" ? (
//               <ChevronLeftIcon sx={{ color: "white" }} />
//             ) : (
//               <ChevronRightIcon sx={{ color: "white" }} />
//             )}
//           </IconButton>
//         </DrawerHeader>
//         <Divider />
//         <List>
//           <ListItem disablePadding>
//             <ListItemButton onClick={handleBox1Toggle}>
//               <ListItemIcon>
//                 <GroupIcon sx={{ color: "white" }}></GroupIcon>
//               </ListItemIcon>
//               <ListItemText primary="Attendance" sx={{ color: "white" }} />
//             </ListItemButton>
//           </ListItem>
          
          
//         </List>
//         <div
//           style={{
//             position: "absolute",
//             bottom: 0,
//             width: "100%",
//             textAlign: "center",
//           }}
//         >
         
//         </div>
//       </Drawer>
//       <Main open={open}>
//         <DrawerHeader />
        
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6} md={4} xl={3} style={{ width: "100%" }}>
//               <Typography
//                 sx={{ fontFamily: "Times New Roman", fontSize: "20px" }}
//                 display={"flex"}
//                 marginTop={"5px"}
//                 marginBottom={"5px"}
//               >
//                 DAILY ATTENDANCE
//               </Typography>

//               <Grid item xs={8} marginBottom={"10px"}>
//                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                   <DemoContainer components={["DatePicker", "DatePicker"]}>
//                     <DatePicker
//                       label="Date"
//                       value={selectedDate}
//                       onChange={(newValue) => setSelectedDate(newValue)}
//                     />
//                   </DemoContainer>
//                 </LocalizationProvider>
//               </Grid>

//               <Table stickyHeader style={{ width: "100%", backgroundColor:"red" }} component={Paper}>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       ID
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       TIME
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       DATE
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       CLOCK
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       SYNC STATUS
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       UPDATE DATE
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         textAlign: "center",
//                         backgroundColor: "lightgrey",
//                         fontFamily: "segoe ui",
//                         fontSize: 15,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       UPDATE TIME
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {SearchResults.map((item, index) => (
//                     <TableRow
//                       key={index}
//                       sx={{
//                         borderRadius: 10, // Reduced the border radius
//                         marginBottom: "16px", // Reduced the space between rows
//                         transition: "background-color 0.3s, transform 0.3s",
//                         "&:hover": {
//                           backgroundColor: "#BBDEFB",
//                           transform: "translateY(-5px)", // Adjusted the lift effect
//                         },
//                       }}
//                     >
//                       <TableCell
//                         align="center"
//                         sx={{ maxWidth: "200px", backgroundColor: "#ffcccb" }}
//                       >
//                         {" "}
//                         {item.BarcodeNo}
//                       </TableCell>

//                       <TableCell
//                         align="center"
//                         sx={{ maxWidth: "200px", backgroundColor: "#ddffdd" }}
//                       >
//                         {" "}
//                         {item.BarcodeTime}
//                       </TableCell>

//                       <TableCell align="center" sx={{ maxWidth: "200px" }}>
//                         {" "}
//                         {item.BarcodeDate}
//                       </TableCell>

//                       <TableCell align="center" sx={{ maxWidth: "200px" }}>
//                         {" "}
//                         {item.ClockNo}
//                       </TableCell>

//                       <TableCell align="center" sx={{ maxWidth: "200px" }}>
//                         {" "}
//                         {item.BarcodeSyncStatus === "N"
//                           ? "NO"
//                           : item.BarcodeSyncStatus === "Y"
//                           ? "YES"
//                           : ""}
//                       </TableCell>

//                       <TableCell align="center" sx={{ maxWidth: "200px" }}>
//                         {" "}
//                         {item.UpdateDate}
//                       </TableCell>

//                       <TableCell align="center" sx={{ maxWidth: "200px" }}>
//                         {" "}
//                         {item.UpdateTime}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </Grid>
//           </Grid>
        
       
//       </Main>
//     </Box>
//   );
// }


import * as React from "react";
import { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Drawer,
  CssBaseline,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Grid,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TableContainer,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Group as GroupIcon,
} from "@mui/icons-material";
import { useAuth } from "../Components/Authcontext";
import axios from "axios";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function Attendance() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [SearchResults, setSearchResults] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const { logout } = useAuth();

  const handleLogout = () => logout();

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://esystems.cdl.lk/backend-Test/RFIDAttendance/RFIDForDGES/GetRFIDdetails?date=${selectedDate.format(
  //           "YYYY-MM-DD"
  //         )}`
  //       );
  //       setSearchResults(response.data?.ResultSet || []);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   fetchData();
  // }, [selectedDate]);


  useEffect(() => {
  const fetchData = async () => {
    try {
      const username = JSON.parse(localStorage.getItem("token")); // get logged-in user

      let apiUrl = "";

      if (username === "Admin") {
        apiUrl = `https://esystems.cdl.lk/backend-Test/RFIDAttendance/RFIDForDGES/GetRFIDdetails?date=${selectedDate.format(
          "YYYY-MM-DD"
        )}`;
      } else {
        apiUrl = `https://esystems.cdl.lk/backend-test/DGESSiteAttendance/RFIDForDGES/GetRFIDdetails?date=${selectedDate.format(
          "YYYY-MM-DD"
        )}&dno=17`;
      }

      const response = await axios.get(apiUrl);
      setSearchResults(response.data?.ResultSet || []);
    } catch (error) {
      console.error(error);
    }
  };

  fetchData();
}, [selectedDate]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open} sx={{ backgroundColor: "#080c6d" }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Attend Me Pro
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={handleLogout}
            sx={{ marginLeft: "auto" }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#080c6d",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon sx={{ color: "white" }} />
            ) : (
              <ChevronRightIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <GroupIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Attendance" sx={{ color: "white" }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      <Main open={open}>
        <DrawerHeader />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              sx={{ fontFamily: "Times New Roman", fontSize: "20px" }}
              display={"flex"}
              mb={1}
            >
              DAILY ATTENDANCE
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label="Date"
                  value={selectedDate}
                  onChange={(newValue) => setSelectedDate(newValue)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "ID",
                      "TIME",
                      "DATE",
                      "CLOCK",
                      "SYNC STATUS",
                      "UPDATE DATE",
                      "UPDATE TIME",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        align="center"
                        sx={{
                          backgroundColor: "lightgrey",
                          fontFamily: "Segoe UI",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SearchResults.length > 0 ? (
                    SearchResults.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          transition: "background-color 0.3s, transform 0.3s",
                          "&:hover": {
                            backgroundColor: "#BBDEFB",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        <TableCell align="center" sx={{background:"rgb(255, 204, 203)"}}>{item.BarcodeNo}</TableCell>
                        <TableCell align="center" sx={{background:"rgb(221, 255, 221)"}}>{item.BarcodeTime}</TableCell>
                        <TableCell align="center">{item.BarcodeDate}</TableCell>
                        <TableCell align="center">{item.ClockNo}</TableCell>
                        <TableCell align="center">
                          {item.BarcodeSyncStatus === "N"
                            ? "NO"
                            : item.BarcodeSyncStatus === "Y"
                            ? "YES"
                            : ""}
                        </TableCell>
                        <TableCell align="center">{item.UpdateDate}</TableCell>
                        <TableCell align="center">{item.UpdateTime}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Main>
    </Box>
  );
}
